module.exports = __webpack_public_path__ + "static/media/needs-8-outline.a26f4caf.png";